<div class="card neg-card">
  <button
    type="button"
    class="back-btn"
    [disabled]="submitting"
    (click)="back.emit()"
  >
    ← Back
  </button>

  <div class="neg-head">
    <div>
      <div class="neg-title">We value your feedback</div>
      <p class="neg-sub">
        Please share your experience with us so we can serve you better.
      </p>
    </div>
  </div>

  <!-- Bootstrap loading skeleton -->
  <div class="neg-skel" *ngIf="bootLoading">
    <div class="skel line w70"></div>
    <div class="skel-chips">
      <div class="skel chip"></div>
      <div class="skel chip"></div>
      <div class="skel chip"></div>
      <div class="skel chip"></div>
    </div>
  </div>

  <!-- Bootstrap failed — slug is kept, retry just re-fetches -->
  <div class="neg-error" *ngIf="!bootLoading && bootError">
    <p>⚠️ Could not load the feedback options. Please try again.</p>
    <button type="button" class="retry-btn" (click)="fetchBootstrap()">
      Retry
    </button>
  </div>

  <ng-container *ngIf="!bootLoading && !bootError">
    <!-- Keywords: what went wrong (from bootstrap keywords.negative) -->
    <div class="section-label">What can we improve?</div>
    <div class="chip-wrap">
      <button
        type="button"
        class="chip chip-neg"
        *ngFor="let kw of keywords"
        [class.selected]="isKeywordSelected(kw)"
        (click)="toggleKeyword(kw)"
      >
        {{ kw.text }}
      </button>
    </div>

    <!-- Word intents (v2 UI only), derived from the bootstrap pool -->
    <ng-container *ngIf="showWordIntents && wordOptions.length">
      <div class="section-label">
        Pick the details (optional)
        <span class="count-badge"
          >{{ selectedWords.length }}/{{ maxWords }}</span
        >
      </div>
      <div class="chip-wrap">
        <button
          type="button"
          class="chip chip-word"
          *ngFor="let w of wordOptions"
          [class.selected]="isWordSelected(w)"
          [disabled]="!isWordSelected(w) && selectedWords.length >= maxWords"
          (click)="toggleWord(w)"
        >
          {{ w }}
        </button>
      </div>
    </ng-container>

    <!-- Free text -->
    <div class="section-label">Anything else? (optional)</div>
    <textarea
      class="neg-textarea"
      rows="4"
      placeholder="Share more about what happened…"
      [(ngModel)]="feedbackText"
    ></textarea>

    <button
      type="button"
      class="cta"
      [disabled]="submitting"
      (click)="submit()"
    >
      <span *ngIf="!submitting">Submit feedback</span>
      <span *ngIf="submitting">Sending…</span>
    </button>
  </ng-container>
</div>
